(function () {
  'use strict';

  var NAV_SELECTOR = '[data-wynch-native-pagination]';
  var LIST_SELECTOR = '.product-card-list.boost-pfs-filter-products';
  var CARD_SELECTOR = ':scope > .product-card';
  var NEXT_SELECTOR = '.next a';
  var LOAD_MORE_SELECTOR = '.boost-pfs-filter-load-more-loading';
  var GLOBAL_LOADING_SELECTOR = '.boost-pfs-filter-loading';
  var BOOST_INFINITE_RUNTIME_SELECTOR = '.boost-pfs-filter-products-container .boost-pfs-filter-load-more';
  var ROOT_MARGIN = '1200px 0px';
  var BOOST_GRACE_PERIOD_MS = 4000;

  function hasActiveRefinement(search) {
    var params = new URLSearchParams(search || window.location.search);
    return Array.from(params.keys()).some(function (key) {
      return key === 'sort' || key === 'sort_by' || key.indexOf('pf_') === 0;
    });
  }

  function absoluteUrl(value) {
    if (!value) return '';
    try {
      return new URL(value, window.location.origin).href;
    } catch (error) {
      return '';
    }
  }

  function productIdentity(card) {
    if (card.dataset.id) return 'id:' + card.dataset.id;
    var link = card.querySelector('a[href*="/products/"]');
    return link ? 'url:' + absoluteUrl(link.getAttribute('href')) : '';
  }

  function boostOwnsInfiniteScroll(scope) {
    var configuredForInfiniteScroll = typeof window.boostPFSConfig === 'object' &&
      window.boostPFSConfig !== null &&
      window.boostPFSConfig.settings &&
      window.boostPFSConfig.settings.general &&
      window.boostPFSConfig.settings.general.paginationType === 'infinite';
    var runtimeRoot = scope || document;
    var runtimeOwnsInfiniteScroll = typeof runtimeRoot.querySelector === 'function' &&
      Boolean(runtimeRoot.querySelector(BOOST_INFINITE_RUNTIME_SELECTOR));

    return configuredForInfiniteScroll || runtimeOwnsInfiniteScroll;
  }

  function CatalogInfiniteScroll(nav) {
    this.nav = nav;
    this.root = nav.closest('.shopify-section') || document;
    this.sentinel = document.createElement('div');
    this.sentinel.className = 'wynch-catalog-infinite-scroll-sentinel';
    this.sentinel.setAttribute('aria-live', 'polite');
    this.nextUrl = this.readNextUrl(nav);
    this.loading = false;
    this.waitingForBoost = false;
    this.observer = null;
    this.productObserver = null;
    var list = this.root.querySelector(LIST_SELECTOR);
    this.lastKnownProductCount = list ? list.querySelectorAll(CARD_SELECTOR).length : 0;
    this.hasAppendedProducts = false;
  }

  CatalogInfiniteScroll.prototype.readNextUrl = function (scope) {
    var next = scope.querySelector(NEXT_SELECTOR);
    return next ? absoluteUrl(next.getAttribute('href')) : '';
  };

  CatalogInfiniteScroll.prototype.setLoading = function (active) {
    var boostLoader = this.root.querySelector(LOAD_MORE_SELECTOR);
    var desiredDisplay = active ? 'block' : 'none';
    if (boostLoader && boostLoader.style.display !== desiredDisplay) {
      boostLoader.style.display = desiredDisplay;
    }
    if (!active) {
      // Boost mounts this page-level loader outside the collection section.
      document.querySelectorAll(GLOBAL_LOADING_SELECTOR).forEach(function (loader) {
        if (loader.style.display !== 'none') loader.style.display = 'none';
      });
    }
    this.sentinel.textContent = active ? (this.nav.dataset.loadingLabel || '') : '';
  };

  CatalogInfiniteScroll.prototype.showFallback = function () {
    this.nav.hidden = false;
    this.sentinel.textContent = this.nav.dataset.errorLabel || '';
    if (this.observer) this.observer.disconnect();
  };

  CatalogInfiniteScroll.prototype.advanceNextUrl = function () {
    var current = new URL(this.nextUrl);
    var currentPage = Number.parseInt(current.searchParams.get('page') || '2', 10);
    var lastPage = Array.from(this.nav.querySelectorAll('.page a'))
      .map(function (link) {
        return Number.parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10);
      })
      .reduce(function (maximum, page) { return Math.max(maximum, page); }, 1);

    if (currentPage >= lastPage) {
      this.nextUrl = '';
      if (this.observer) this.observer.disconnect();
      return;
    }

    current.searchParams.set('page', String(currentPage + 1));
    this.nextUrl = current.href;
  };

  CatalogInfiniteScroll.prototype.waitForBoost = function () {
    if (this.waitingForBoost || this.loading || !this.nextUrl) return;

    var list = this.root.querySelector(LIST_SELECTOR);
    if (!list) return;
    var requestedPage = Number.parseInt(new URL(this.nextUrl).searchParams.get('page') || '2', 10);
    var locationPage = Number.parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    if (locationPage >= requestedPage) {
      this.advanceNextUrl();
      this.setLoading(false);
      return;
    }
    var countBefore = list.querySelectorAll(CARD_SELECTOR).length;
    this.waitingForBoost = true;

    window.setTimeout(function () {
      if (!this.waitingForBoost) return;
      this.waitingForBoost = false;
      var currentList = this.root.querySelector(LIST_SELECTOR);
      var countAfter = currentList ? currentList.querySelectorAll(CARD_SELECTOR).length : countBefore;
      if (countAfter > countBefore) {
        this.advanceNextUrl();
        this.setLoading(false);
        return;
      }
      this.loadNext();
    }.bind(this), BOOST_GRACE_PERIOD_MS);
  };

  CatalogInfiniteScroll.prototype.observeProductChanges = function () {
    if (!('MutationObserver' in window)) return;

    this.productObserver = new MutationObserver(function () {
      var currentList = this.root.querySelector(LIST_SELECTOR);
      var currentCount = currentList ? currentList.querySelectorAll(CARD_SELECTOR).length : 0;
      if (currentCount > this.lastKnownProductCount) {
        this.lastKnownProductCount = currentCount;
        if (!this.waitingForBoost) return;

        this.hasAppendedProducts = true;
        this.waitingForBoost = false;
        this.advanceNextUrl();
        this.setLoading(false);
        return;
      }

      // Boost can throw in its afterRender hook after products were already
      // inserted, leaving the global spinner visible. Once no page is pending,
      // a later style mutation to `display: block` is stale and must be cleared.
      if (this.hasAppendedProducts && !this.waitingForBoost && !this.loading) {
        this.setLoading(false);
      }
    }.bind(this));
    this.productObserver.observe(this.root, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true
    });
  };

  CatalogInfiniteScroll.prototype.appendPage = function (html, requestedUrl) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var incomingList = parsed.querySelector(LIST_SELECTOR);
    var currentList = this.root.querySelector(LIST_SELECTOR);
    var incomingNav = parsed.querySelector(NAV_SELECTOR);

    if (!incomingList || !currentList || !incomingNav) {
      throw new Error('WYNCH_CATALOG_PAGE_MARKUP_INVALID');
    }

    var identities = new Set(Array.from(currentList.querySelectorAll(CARD_SELECTOR)).map(productIdentity));
    var fragment = document.createDocumentFragment();
    var appended = 0;

    incomingList.querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      var identity = productIdentity(card);
      if (identity && identities.has(identity)) return;
      if (identity) identities.add(identity);
      fragment.appendChild(card);
      appended += 1;
    });

    currentList.appendChild(fragment);
    this.nextUrl = this.readNextUrl(incomingNav);
    this.nav.innerHTML = incomingNav.innerHTML;
    this.nav.dataset.wynchLastLoadedPage = new URL(requestedUrl).searchParams.get('page') || '';

    document.dispatchEvent(new CustomEvent('wynch:catalog:page-appended', {
      detail: { url: requestedUrl, appended: appended }
    }));
  };

  CatalogInfiniteScroll.prototype.loadNext = function () {
    if (this.loading || !this.nextUrl) return;

    var requestedUrl = this.nextUrl;
    this.loading = true;
    this.setLoading(true);

    fetch(requestedUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('WYNCH_CATALOG_PAGE_HTTP_' + response.status);
        return response.text();
      })
      .then(function (html) {
        this.appendPage(html, requestedUrl);
        this.loading = false;
        this.setLoading(false);
        if (!this.nextUrl && this.observer) this.observer.disconnect();
      }.bind(this))
      .catch(function (error) {
        this.loading = false;
        this.setLoading(false);
        this.showFallback();
        console.error('[WYNCH catalog pagination]', error);
      }.bind(this));
  };

  CatalogInfiniteScroll.prototype.start = function () {
    if (!this.nextUrl || hasActiveRefinement(window.location.search)) return;
    if (!('IntersectionObserver' in window) || !('fetch' in window) || !('DOMParser' in window)) return;

    this.nav.insertAdjacentElement('beforebegin', this.sentinel);
    this.nav.hidden = true;
    this.nav.dataset.wynchInfiniteScrollReady = 'true';
    this.observeProductChanges();
    this.observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      // Boost initializes asynchronously and can claim the same intersection
      // after this script has started. Always give it one grace period before
      // the native fallback fetches, otherwise both loaders race for the page.
      this.waitForBoost();
    }.bind(this), { rootMargin: ROOT_MARGIN });
    this.observer.observe(this.sentinel);
  };

  function initialize(nav) {
    if (nav.dataset.wynchInfiniteScrollReady === 'true') return;
    new CatalogInfiniteScroll(nav).start();
  }

  function initializeAll(scope) {
    (scope || document).querySelectorAll(NAV_SELECTOR).forEach(initialize);
  }

  window.WynchCatalogInfiniteScroll = {
    boostOwnsInfiniteScroll: boostOwnsInfiniteScroll,
    hasActiveRefinement: hasActiveRefinement,
    productIdentity: productIdentity,
    initializeAll: initializeAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
